(() => {
  const mobileAccordion = document.querySelector('.-js-mobile-accordion');

  if (mobileAccordion === null) return;

  const mobileAccordionNodes = Array.from(mobileAccordion.querySelectorAll('.js-accordion-panel'));
  const mobileAccordionContainer = document.querySelector('.MobileAccordion');

  // Clone all topics
  mobileAccordionNodes.forEach(el => {
    const clonedElement = el.cloneNode(true);
    const li = document.createElement('li');

    const toggle = clonedElement.querySelector('.js-topic-headline');
    toggle.classList.add('Accordion-toggle');

    const inner = clonedElement.querySelector('.js-topic-content');
    inner.classList.add('Accordion-inner');

    li.appendChild(clonedElement);
    mobileAccordionContainer.appendChild(li);
  });

  // Set active element
  document.querySelector('.MobileAccordion li:first-of-type').classList.add('is-active');
})();
